//previous code of webcamfileUpload

// import React, { useRef, useState } from 'react';
// import Webcam from 'react-webcam';
// import { Modal, Button } from 'react-bootstrap';
// import { FaCheckSquare, FaRegSquare } from 'react-icons/fa';
// import { useDispatch } from 'react-redux';
// import { showToast } from 'Core/redux/toast/slice';
// import { useDocumentUpload } from 'Core/hooks';
// import { MOLD_TYPE } from '../../constants/moldConstants';
// import { sanitizeUploadKey } from '../sanitizeUploadKeys/sanitizeUploadKeys';
// import { FaCamera, FaSyncAlt } from 'react-icons/fa';
// import './webcam-multi-capture-modal.css';

// const WebcamMultiCaptureModal = ({ show, onClose, onSubmit }) => {
//   const dispatch = useDispatch();
//   const { imageDocuments } = useDocumentUpload();

//   const webcamRef = useRef(null);
//   const [images, setImages] = useState([]); 
//   const [facingMode, setFacingMode] = useState('environment'); 

//   const videoConstraints = {
//   facingMode: facingMode,
//   };

//   const captureImage = async () => {
//     const imageSrc = webcamRef.current.getScreenshot();
//     if (imageSrc) {
//       const id = Date.now();
//       setImages(prev => [...prev, { id, src: imageSrc, isSelected: true }]);
//     }
//   };

//   const toggleSelect = id => {
//     setImages(prev =>
//       prev.map(img => (img.id === id ? { ...img, isSelected: !img.isSelected } : img)),
//     );
//   };

//   const flipCamera = async () => {
//     try {
//       const devices = await navigator.mediaDevices.enumerateDevices();
//       const videoInputs = devices.filter(device => device.kind === 'videoinput');

//       if (videoInputs.length < 2) {
//         dispatch(
//           showToast({ message: 'No back camera or external webcam available', type: 'warning' }),
//         );
//         return;
//       }

//       setFacingMode(prev => (prev === 'user' ? 'environment' : 'user'));
//     } catch (err) {
//       console.error('Error checking video devices:', err);
//       dispatch(showToast({ message: 'Unable to access video devices', type: 'danger' }));
//     }
//   };

//   const handleSubmit = async () => {
//     const selectedImages = images.filter(img => img.isSelected);

//     if (selectedImages.length === 0) {
//       onClose();
//       return;
//     }

//     const uploadedFiles = [];

//     for (let i = 0; i < selectedImages.length; i++) {
//       const img = selectedImages[i];
//       try {
//         const response = await fetch(img.src);
//         const blob = await response.blob();
//         const safeTimestamp = new Date().toISOString().replace(/[:.]/g, '-');
//         const file = new File([blob], `captured_${safeTimestamp}_${i + 1}.jpg`, {
//           type: 'image/jpeg',
//         });

//         const fileCategoryId = sanitizeUploadKey(MOLD_TYPE.WEBCAM_CAPTURED_IMAGE);
//         const uploadCategory = sanitizeUploadKey(MOLD_TYPE.MOLD_RECEIVING);

//         const docFormData = new FormData();
//         docFormData.append('file', file);
//         docFormData.append('fileCategoryId', fileCategoryId);
//         docFormData.append('uploadCategory', uploadCategory);

//         const result = await imageDocuments(docFormData);

//         if (result && result.relativePath) {
//           uploadedFiles.push({
//             fileName: file.name,
//             relativePath: result.relativePath,
//             filePath: result.relativePath,
//           });
//         }
//       } catch (err) {
//         console.error('Image upload failed', err);
//       }
//     }

//     if (uploadedFiles.length > 0) {
//       dispatch(showToast({ message: 'All Images Uploaded', type: 'success' }));
//     }

//     setImages([]);
//     onClose();
//     onSubmit(uploadedFiles);
//   };

//   return (
//     <Modal show={show} onHide={onClose} centered dialogClassName="webcam-modal">
//       <Modal.Header closeButton>
//         <Modal.Title>Capture Images</Modal.Title>
//       </Modal.Header>

//       <Modal.Body className="webcam-modal-body">
//         <div className="webcam-container">
//           <Webcam
//             key={facingMode} // re-initialize on flip
//             audio={false}
//             ref={webcamRef}
//             screenshotFormat="image/jpeg"
//             width={500}
//             height={350}
//             videoConstraints={videoConstraints}
//           />
//         </div>
//         <div className="action-buttons">
//           <Button size="sm" variant="secondary" onClick={flipCamera} className="action-btn">
//             <FaSyncAlt />
//             Flip Camera
//           </Button>
//           <Button size="sm" variant="primary" onClick={captureImage} className="action-btn">
//             <FaCamera />
//             Capture Photo
//           </Button>
//         </div>

//         {/* <div className="d-flex flex-wrap justify-content-center mt-3"> */}
//         <div className="captured-images">
//           {images.map(img => (
//             <div key={img.id} className="thumbnail">
//               <img src={img.src} alt="Captured" className="thumbnail-img" />
//               <span onClick={() => toggleSelect(img.id)} className="thumbnail-check">
//                 {img.isSelected ? <FaCheckSquare color="green" /> : <FaRegSquare color="gray" />}
//               </span>
//             </div>
//           ))}
//         </div>
//       </Modal.Body>

//       <Modal.Footer>
//         <Button variant="secondary" onClick={onClose}>
//           Cancel
//         </Button>
//         <Button variant="success" onClick={handleSubmit} disabled={images.length === 0}>
//           Save Selected Images
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// export default WebcamMultiCaptureModal;


//latest webcamfileupload code

import React, { useRef, useState, useEffect } from 'react';
import Webcam from 'react-webcam';
import { Modal, Button } from 'react-bootstrap';
import { FaCheckSquare, FaRegSquare, FaCamera, FaSyncAlt, FaUpload, FaTimes } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { showToast } from 'Core/redux/toast/slice';
import { useDocumentUpload } from 'Core/hooks';
import { MOLD_TYPE } from '../../constants/moldConstants';
import { sanitizeUploadKey } from '../sanitizeUploadKeys/sanitizeUploadKeys';
import { MoldService } from '../../../service/api/mold-service';
import { CellService } from '../../../service/api/cell-service';
import { AuxiliaryEquipmentService } from '../../../service/api/auxiliary-equipment-service';
import { ForkliftService } from '../../../service/api/forklift-service';
import { WaterTowersService } from '../../../service/api/water-towers-service';
import { AirCompressorsService } from '../../../service/api/air-compressors-service';
import { PlantService } from '../../../service/api/plant-service';
import { RobotsService } from '../../../service/api/robots-service';
import { OverheadCraneService } from '../../../service/api/overhead-crane-service';
import LoadingSpinner from '../../../InitialPage/Sidebar/LoadingSpinner';
import ZoomableImageModal from '../zoomableimagemodal/ZoomableImageModal';
import './webcam-multi-capture-modal.css';

const defaultSlots = [
  { key: 'general', label: 'General' },
  { key: 'segment1', label: 'Segment 1' },
];

const WebcamMultiCaptureModal = ({ show, onClose, onSubmit, toolID, moldInfoID, buttonLabel, maintenanceId = 0, onImageSegmentUploaded, maintenanceData, onMaintenanceSaved, context = 'maintenance', onDraftIdUpdate }) => {
  const dispatch = useDispatch();
  const { imageDocuments } = useDocumentUpload();

  const webcamRef = useRef(null);
  //const [images, setImages] = useState([]); // [{ id, src, isSelected }]
  const [facingMode, setFacingMode] = useState('environment'); // Default to back camera
  const [slots, setSlots] = useState(defaultSlots);
  const [slotImages, setSlotImages] = useState({});
  const [activeSlot, setActiveSlot] = useState(defaultSlots[0].key);
  const [isLoading, setIsLoading] = useState(false);
  const [isCameraLoading, setIsCameraLoading] = useState(false);
  const [uploadedImageUrls, setUploadedImageUrls] = useState([]);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [pendingImages, setPendingImages] = useState([]);
  const [showUploadArea, setShowUploadArea] = useState(false);
  
  // Image editor state
  const [showImageEditor, setShowImageEditor] = useState(false);
  const [editingImage, setEditingImage] = useState(null);
  const [editingSlot, setEditingSlot] = useState(null);
  const [isProcessingImages, setIsProcessingImages] = useState(false);
  const [processingProgress, setProcessingProgress] = useState({ current: 0, total: 0 });

  const videoConstraints = {
    facingMode: facingMode,
  };

  //* Capture image into active slot
  const captureImage = async () => {
    if (!activeSlot) return;
    const imageSrc = webcamRef.current.getScreenshot();
    if (imageSrc) {
      const id = `${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;
      setSlotImages(prev => {
        const arr = prev[activeSlot] || [];
        return { ...prev, [activeSlot]: [...arr, { id, src: imageSrc, isSelected: true }] };
      });
    }
  };

  //*new
  const toggleSelect = (slotKey, id) => {
    setSlotImages(prev => ({
      ...prev,
      [slotKey]: (prev[slotKey] || []).map(img =>
        img.id === id ? { ...img, isSelected: !img.isSelected } : img,
      ),
    }));
  };

  const flipCamera = async () => {
    setIsCameraLoading(true);
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoInputs = devices.filter(device => device.kind === 'videoinput');

      if (videoInputs.length < 2) {
        dispatch(
          showToast({ message: 'No back camera or external webcam available', type: 'warning' }),
        );
        return;
      }

      setFacingMode(prev => (prev === 'user' ? 'environment' : 'user'));
    } catch (err) {
      console.error('Error checking video devices:', err);
      dispatch(showToast({ message: 'Unable to access video devices', type: 'danger' }));
    } finally {
      setIsCameraLoading(false);
    }
  };

  // Add new custom slot
  const addSlot = () => {
    const newKey = `slot_${Date.now()}`;
    setSlots(prev => [...prev, { key: newKey, label: 'New Segment' }]);
    setActiveSlot(newKey);
  };

  // Handle file selection for active slot
  const handleFileSelect = async (event) => {
    const files = Array.from(event.target.files);
    if (files.length === 0) return;

    // Filter image files (including HEIC/HEIF)
    const imageFiles = files.filter(file => {
      const isImage = file.type.startsWith('image/');
      const isHeic = file.name.toLowerCase().endsWith('.heic') || 
                     file.name.toLowerCase().endsWith('.heif');
      return isImage || isHeic;
    });

    if (imageFiles.length !== files.length) {
      dispatch(showToast({ 
        message: 'Only image files (including HEIC) are allowed', 
        type: 'warning' 
      }));
    }

    if (imageFiles.length > 0) {
      let processedCount = 0;
      const totalFiles = imageFiles.length;
      const errors = [];

      // Set loading state
      setIsProcessingImages(true);
      setProcessingProgress({ current: 0, total: totalFiles });

      // Process each file (convert HEIC and compress)
      for (let i = 0; i < imageFiles.length; i++) {
        const file = imageFiles[i];
        setProcessingProgress({ current: i + 1, total: totalFiles });
        try {
          // Import image processor utilities
          const { processImageFile } = await import('Core/utils/imageProcessor');
          
          // Process the file (convert HEIC if needed, then compress)
          const processedFile = await processImageFile(file, {
            maxSizeMB: 2, // Maximum 2MB per file
            maxWidthOrHeight: 1920, // Maximum dimension
            quality: 0.85 // Good quality balance
          });

          // Read the processed file
          const reader = new FileReader();
          reader.onload = (e) => {
            const id = `${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;
            setSlotImages(prev => {
              const arr = prev[activeSlot] || [];
              return { 
                ...prev, 
                [activeSlot]: [...arr, { 
                  id, 
                  src: e.target.result, 
                  isSelected: true,
                  file: processedFile, // Use processed file instead of original
                  isUploaded: false,
                  originalFileName: file.name // Keep original name for reference
                }] 
              };
            });
            
            processedCount++;
            // Close upload area after all files are processed
            if (processedCount === totalFiles) {
              setIsProcessingImages(false);
              setProcessingProgress({ current: 0, total: 0 });
              setShowUploadArea(false);
              const successMessage = errors.length > 0 
                ? `${processedCount} image(s) uploaded, ${errors.length} failed`
                : `${totalFiles} image(s) uploaded successfully!`;
              dispatch(showToast({ 
                message: successMessage, 
                type: errors.length > 0 ? 'warning' : 'success' 
              }));
            }
          };
          reader.onerror = () => {
            errors.push(file.name);
            processedCount++;
            if (processedCount === totalFiles) {
              setIsProcessingImages(false);
              setProcessingProgress({ current: 0, total: 0 });
              setShowUploadArea(false);
              dispatch(showToast({ 
                message: errors.length > 0 
                  ? `${processedCount - errors.length} uploaded, ${errors.length} failed`
                  : `${totalFiles} image(s) uploaded successfully!`, 
                type: errors.length > 0 ? 'warning' : 'success' 
              }));
            }
          };
          reader.readAsDataURL(processedFile);
        } catch (error) {
          console.error('Error processing file:', file.name, error);
          errors.push(file.name);
          processedCount++;
          
          // If processing fails, try to use original file
          const reader = new FileReader();
          reader.onload = (e) => {
            const id = `${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;
            setSlotImages(prev => {
              const arr = prev[activeSlot] || [];
              return { 
                ...prev, 
                [activeSlot]: [...arr, { 
                  id, 
                  src: e.target.result, 
                  isSelected: true,
                  file: file,
                  isUploaded: false
                }] 
              };
            });
            
            if (processedCount === totalFiles) {
              setIsProcessingImages(false);
              setProcessingProgress({ current: 0, total: 0 });
              setShowUploadArea(false);
              dispatch(showToast({ 
                message: errors.length > 0 
                  ? `${processedCount - errors.length} uploaded, ${errors.length} failed`
                  : `${totalFiles} image(s) uploaded successfully!`, 
                type: errors.length > 0 ? 'warning' : 'success' 
              }));
            }
          };
          reader.readAsDataURL(file);
        }
      }
    }
    
    // Reset the input
    event.target.value = '';
  };

  // Handle drag and drop
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const files = Array.from(e.dataTransfer.files);
    if (files.length > 0) {
      const event = { target: { files } };
      handleFileSelect(event);
    }
  };

  // Remove image from slot
  const removeImage = (slotKey, id) => {
    setSlotImages(prev => ({
      ...prev,
      [slotKey]: (prev[slotKey] || []).filter(img => img.id !== id)
    }));
  };

  // Open image editor
  const handleEditImage = (slotKey, img) => {
    setEditingSlot(slotKey);
    setEditingImage(img);
    setShowImageEditor(true);
  };

  // Save edited image
  const handleSaveEditedImage = async (editedBlob) => {
    if (!editingImage || !editingSlot) return;

    try {
      // Convert blob to base64 data URL
      const reader = new FileReader();
      reader.onload = (e) => {
        const editedSrc = e.target.result;
        
        // Update the image in slotImages
        setSlotImages(prev => ({
          ...prev,
          [editingSlot]: (prev[editingSlot] || []).map(img =>
            img.id === editingImage.id
              ? { ...img, src: editedSrc, isEdited: true }
              : img
          )
        }));
        
        dispatch(showToast({ 
          message: 'Image edited successfully!', 
          type: 'success' 
        }));
        
        // Close the editor
        setShowImageEditor(false);
        setEditingImage(null);
        setEditingSlot(null);
      };
      reader.readAsDataURL(editedBlob);
    } catch (error) {
      console.error('Error saving edited image:', error);
      dispatch(showToast({ 
        message: 'Failed to save edited image', 
        type: 'danger' 
      }));
    }
  };
  // Handle submit - Check maintenanceId and show confirmation dialog if needed
  const handleSubmit = () => {
    // Collect all selected images first
    const selectedImages = [];
    for (const slot of slots) {
      const images = (slotImages[slot.key] || []).filter(i => i.isSelected);
      for (const img of images) {
        selectedImages.push({
          slot,
          img,
          slotKey: slot.key
        });
      }
    }
    
    if (selectedImages.length === 0) {
      dispatch(showToast({ message: 'No images selected', type: 'warning' }));
      return;
    }
    
    setPendingImages(selectedImages);
    
    // Check if maintenanceId exists
    if (maintenanceId && maintenanceId > 0) {
      // If maintenanceId exists, skip confirmation and proceed directly
      console.log('Webcam modal: maintenanceId exists, skipping confirmation dialog');
      handleConfirmSubmit();
    } else {
      // If no maintenanceId, show confirmation dialog
      console.log('Webcam modal: No maintenanceId, showing confirmation dialog');
      setShowConfirmDialog(true);
    }
  };

  // Handle confirmation and proceed with upload
  const handleConfirmSubmit = async () => {
    setShowConfirmDialog(false);
    setIsLoading(true);
    
    try {
      let finalMoldInfoId = moldInfoID;
      let finalMaintenanceId = maintenanceId;
      let finalMoldReceivingId = moldInfoID; // Store the actual mold receiving ID for release context
      
      if (context === 'receiving') {
        // For Mold Receiving context, call saveOrUpdateMoldReceiving API
        if (maintenanceData) {
          console.log('Webcam modal: Saving mold receiving record with data:', maintenanceData);
          console.log('Webcam modal: CustomerId in maintenanceData:', maintenanceData.CustomerId);
          console.log('Webcam modal: MaterialType in maintenanceData:', maintenanceData.materialType);
          console.log('Webcam modal: moldDocuments in maintenanceData:', maintenanceData.moldDocuments);
          console.log('Webcam modal: moldDocuments length:', maintenanceData.moldDocuments?.length);
          console.log('Webcam modal: toolID in maintenanceData:', maintenanceData.toolID);
          
          try {
            // Prepare payload: exclude any imageSegments to avoid validation errors on receiving API
            const { imageSegments, ImageSegments, ...receivingPayload } = maintenanceData || {};
            if (imageSegments || ImageSegments) {
              console.log('Webcam modal: Stripping imageSegments from payload before saveOrUpdateMoldReceiving.', {
                removedImageSegmentsLength: (imageSegments || ImageSegments)?.length || 0,
              });
            }
            
            // Ensure moldDocuments are included in the payload
            if (maintenanceData.moldDocuments && maintenanceData.moldDocuments.length > 0) {
              // Convert moldDocuments array to JSON string as expected by the stored procedure
              receivingPayload.Documents = JSON.stringify(maintenanceData.moldDocuments);
              console.log('Webcam modal: Including moldDocuments as JSON string in payload:', receivingPayload.Documents);
            } else {
              console.log('Webcam modal: No moldDocuments found in maintenanceData');
            }
            
            console.log('Webcam modal: Final payload for saveOrUpdateMoldReceiving:', receivingPayload);
            
            // Call saveOrUpdateMoldReceiving API
            const receivingResponse = await MoldService.saveUpdateReceiving(receivingPayload);
            console.log('Webcam modal: Mold receiving response:', receivingResponse);
            console.log('Webcam modal: Response status:', receivingResponse?.status);
            console.log('Webcam modal: Response data:', receivingResponse?.response);
            console.log('Webcam modal: Response data type:', typeof receivingResponse?.response);
            console.log('Webcam modal: CustomerId in response:', receivingResponse?.response?.CustomerId);
            console.log('Webcam modal: MaterialType in response:', receivingResponse?.response?.materialType);
            
            // Check if the response has the expected structure
            if (receivingResponse && receivingResponse.status === 200 && receivingResponse.response) {
              const responseData = receivingResponse.response;
              console.log('Webcam modal: Response data keys:', Object.keys(responseData));
              console.log('Webcam modal: Looking for moldInfoID, moldInfoId, or id in:', responseData);
              
              if (responseData.moldInfoID || responseData.moldInfoId || responseData.id) {
                finalMoldInfoId = responseData.moldInfoID || responseData.moldInfoId || responseData.id;
                console.log('Webcam modal: Final mold info ID:', finalMoldInfoId);
                console.log('Webcam modal: ToolID from response:', responseData.toolID);
                console.log('Webcam modal: About to call onMaintenanceSaved with:', finalMoldInfoId);
                dispatch(showToast({ message: 'Mold receiving record saved successfully', type: 'success' }));
                
                // Call the callback to update the parent component's maintenanceId
                if (onMaintenanceSaved && typeof onMaintenanceSaved === 'function') {
                  console.log('Webcam modal: Calling onMaintenanceSaved callback');
                  console.log('Webcam modal: onMaintenanceSaved function:', onMaintenanceSaved);
                  console.log('Webcam modal: onMaintenanceSaved type:', typeof onMaintenanceSaved);
                  // Pass both moldInfoID and toolID to the callback
                  onMaintenanceSaved(finalMoldInfoId, responseData.toolID);
                  console.log('Webcam modal: onMaintenanceSaved callback completed');
                } else {
                  console.log('Webcam modal: onMaintenanceSaved is not a function or not provided');
                  console.log('Webcam modal: onMaintenanceSaved value:', onMaintenanceSaved);
                  console.log('Webcam modal: onMaintenanceSaved type:', typeof onMaintenanceSaved);
                }
              } else {
                console.error('Webcam modal: No moldInfoID in response data:', responseData);
                dispatch(showToast({ message: 'Invalid mold receiving response - missing moldInfoID', type: 'danger' }));
                setIsLoading(false);
                return;
              }
            } else {
              console.error('Webcam modal: Invalid mold receiving response structure:', receivingResponse);
              dispatch(showToast({ message: 'Invalid mold receiving response', type: 'danger' }));
              setIsLoading(false);
              return;
            }
          } catch (receivingError) {
            console.error('Webcam modal: Failed to save mold receiving record:', receivingError);
            console.error('Webcam modal: Error details:', receivingError.response || receivingError);
            dispatch(showToast({ message: 'Failed to save mold receiving record', type: 'danger' }));
            setIsLoading(false);
            return;
          }
        }
             } else if (context === 'release') {
         // For Mold Release context, call saveOrUpdateMoldReleaseDraft API
         if (maintenanceData) {
           console.log('Webcam modal: Saving mold release draft record with data:', maintenanceData);
           
                      try {
              // Call saveOrUpdateMoldReleaseDraft API with status field and draft ID if it exists
              const releaseDataWithStatus = {
                ...maintenanceData,
                status: 'Draft',
                // Include draft ID if it exists to update existing draft record
                id: maintenanceData.draftId && maintenanceData.draftId > 0 ? maintenanceData.draftId : 0
              };
              console.log('Webcam modal: Calling saveOrUpdateMoldReleaseDraft with data:', releaseDataWithStatus);
              const releaseResponse = await MoldService.saveOrUpdateMoldReleaseDraft(releaseDataWithStatus);
             console.log('Webcam modal: Mold release draft response:', releaseResponse);
             
             // Check if the response has the expected structure
             if (releaseResponse && releaseResponse.status === 200 && releaseResponse.response) {
               const responseData = releaseResponse.response;
               // Look for the draft ID in the response
               const draftId = responseData.id || responseData.ID || responseData.moldInfoID || responseData.moldInfoId;
               if (draftId && draftId > 0) {
                 finalMoldInfoId = draftId;
                 console.log('Webcam modal: Final draft ID:', finalMoldInfoId);
                 console.log('Webcam modal: Mold receiving ID from response:', responseData.moldInfoID || responseData.moldInfoId);
                 
                 // Store the mold receiving ID from the response for use in image segments
                 finalMoldReceivingId = responseData.moldInfoID || responseData.moldInfoId;
                 
                 // Call the callback to update the parent component's draft ID
                 if (onDraftIdUpdate && typeof onDraftIdUpdate === 'function') {
                   // Pass both the draft ID and the mold receiving ID
                   onDraftIdUpdate(finalMoldInfoId, finalMoldReceivingId);
                 }
                 
                 dispatch(showToast({ message: 'Mold release draft record saved successfully', type: 'success' }));
               } else {
                 console.error('Webcam modal: No draft ID in response data:', responseData);
                 dispatch(showToast({ message: 'Invalid mold release draft response - missing draft ID', type: 'danger' }));
                 setIsLoading(false);
                 return;
               }
             } else {
               console.error('Webcam modal: Invalid mold release draft response structure:', releaseResponse);
               dispatch(showToast({ message: 'Invalid mold release draft response', type: 'danger' }));
               setIsLoading(false);
               return;
             }
           } catch (releaseError) {
             console.error('Webcam modal: Failed to save mold release draft record:', releaseError);
             console.error('Webcam modal: Error details:', releaseError.response || releaseError);
             dispatch(showToast({ message: 'Failed to save mold release draft record', type: 'danger' }));
             setIsLoading(false);
             return;
           }
         }
               } else if (context === 'machine') {
          // For Machine Maintenance context, call saveOrUpdateMachineMaintenance API
          if (maintenanceData) {
            console.log('Webcam modal: Saving machine maintenance record with data:', maintenanceData);
            
            try {
              // Prepare the correct payload structure for machine maintenance
              const machinePayload = {
                id: 0,
                userId: localStorage.getItem('UserId'),
                assetNumber: maintenanceData.assetNumber,
                modelNumber: maintenanceData.modelNumber,
                serialNumber: maintenanceData.serialNumber,
                date: maintenanceData.date,
                location: maintenanceData.location,
                lastServicedBy: maintenanceData.lastServicedBy,
                lastServiceDate: maintenanceData.lastServiceDate,
                specSheetDocument: maintenanceData.specSheetDocument || '',
                serialPlateDocument: maintenanceData.serialPlateDocument || '',
                serviceManualDocument: maintenanceData.serviceManualDocument || '',
                serviceContactDocument: maintenanceData.serviceContactDocument || '',
                oilUsedDocument: maintenanceData.oilUsedDocument || '',
                serviceContractDocuments: maintenanceData.serviceContractDocuments || [],
                notes: maintenanceData.notes || '',
                cellLocation: maintenanceData.cellLocation,
                machineNumber: maintenanceData.machineNumber,
                totalCyclesSinceLastMaint: maintenanceData.totalCyclesSinceLastMaint || 0,
                totalCyclesToDate: maintenanceData.totalCyclesToDate,
                lastMaintenanceDate: maintenanceData.lastMaintenanceDate,
                maintenanceIntervalCycles: String(maintenanceData.maintenanceIntervalCycles || 0), // Convert to string
                currentMaintenanceDate: maintenanceData.currentMaintenanceDate,
                machine: maintenanceData.assetNumber, // Add the required machine field
              };
              
              console.log('Webcam modal: Prepared machine payload:', machinePayload);
              
              // Call saveOrUpdateMachineMaintenance API
              const machineResponse = await CellService.createMachineMaintenanceDetails(machinePayload);
              console.log('Webcam modal: Machine maintenance response:', machineResponse);
              
              // Check if the response has the expected structure
              if (machineResponse && machineResponse.status === 200 && machineResponse.response) {
                const responseData = machineResponse.response;
                if (responseData.id || responseData.ID) {
                  finalMaintenanceId = responseData.id || responseData.ID;
                  console.log('Webcam modal: Final machine maintenance ID:', finalMaintenanceId);
                  dispatch(showToast({ message: 'Machine maintenance record saved successfully', type: 'success' }));
                  
                  // Call the callback to update the parent component's maintenanceId
                  if (onMaintenanceSaved && typeof onMaintenanceSaved === 'function') {
                    onMaintenanceSaved(finalMaintenanceId);
                  }
                } else {
                  console.error('Webcam modal: No ID in machine maintenance response data:', responseData);
                  dispatch(showToast({ message: 'Invalid machine maintenance response - missing ID', type: 'danger' }));
                  setIsLoading(false);
                  return;
                }
              } else {
                console.error('Webcam modal: Invalid machine maintenance response structure:', machineResponse);
                dispatch(showToast({ message: 'Invalid machine maintenance response', type: 'danger' }));
                setIsLoading(false);
                return;
              }
            } catch (machineError) {
              console.error('Webcam modal: Failed to save machine maintenance record:', machineError);
              console.error('Webcam modal: Error details:', machineError.response || machineError);
              dispatch(showToast({ message: 'Failed to save machine maintenance record', type: 'danger' }));
              setIsLoading(false);
              return;
            }
          }
        } else if (context === 'auxiliary-equipment') {
          // For Auxiliary Equipment Maintenance context, call saveOrUpdateAuxiliaryEquipmentMaintenance API
          if (maintenanceData) {
            console.log('Webcam modal: Saving auxiliary equipment maintenance record with data:', maintenanceData);
            
            try {
              // Prepare the correct payload structure for auxiliary equipment maintenance
              const auxiliaryPayload = {
                id: 0,
                userId: localStorage.getItem('UserId'),
                assetNumber: maintenanceData.assetNumber,
                modelNumber: maintenanceData.modelNumber,
                serialNumber: maintenanceData.serialNumber,
                date: maintenanceData.date,
                location: maintenanceData.location,
                lastServicedBy: maintenanceData.lastServicedBy,
                lastServiceDate: maintenanceData.lastServiceDate,
                specSheetDocument: maintenanceData.specSheetDocument || '',
                serialPlateDocument: maintenanceData.serialPlateDocument || '',
                serviceManualDocument: maintenanceData.serviceManualDocument || '',
                serviceContactDocument: maintenanceData.serviceContactDocument || '',
                oilUsedDocument: maintenanceData.oilUsedDocument || '',
                serviceContractDocuments: maintenanceData.serviceContractDocuments || [],
                notes: maintenanceData.notes || '',
                cellLocation: maintenanceData.cellLocation,
                auxiliaryEquipment: maintenanceData.assetNumber,
                totalCyclesSinceLastMaint: maintenanceData.totalCyclesSinceLastMaint || 0,
                totalCyclesToDate: maintenanceData.totalCyclesToDate,
                lastMaintenanceDate: maintenanceData.lastMaintenanceDate,
                maintenanceIntervalCycles: String(maintenanceData.maintenanceIntervalCycles || 0),
                currentMaintenanceDate: maintenanceData.currentMaintenanceDate,
                version: maintenanceData.version || '',
                status: maintenanceData.status || '',
              };
              
              console.log('Webcam modal: Prepared auxiliary equipment payload:', auxiliaryPayload);
              
              // Call saveOrUpdateAuxiliaryEquipmentMaintenance API
              const auxiliaryResponse = await AuxiliaryEquipmentService.saveAuxiliaryEquipmentMaintenance(auxiliaryPayload);
              console.log('Webcam modal: Auxiliary equipment maintenance response:', auxiliaryResponse);
              
              // Check if the response has the expected structure
              if (auxiliaryResponse && auxiliaryResponse.status === 200 && auxiliaryResponse.response) {
                const responseData = auxiliaryResponse.response;
                if (responseData.id || responseData.ID) {
                  finalMaintenanceId = responseData.id || responseData.ID;
                  console.log('Webcam modal: Final auxiliary equipment maintenance ID:', finalMaintenanceId);
                  dispatch(showToast({ message: 'Auxiliary equipment maintenance record saved successfully', type: 'success' }));
                  
                  // Call the callback to update the parent component's maintenanceId
                  if (onMaintenanceSaved && typeof onMaintenanceSaved === 'function') {
                    onMaintenanceSaved(finalMaintenanceId);
                  }
                } else {
                  console.error('Webcam modal: No ID in auxiliary equipment maintenance response data:', responseData);
                  dispatch(showToast({ message: 'Invalid auxiliary equipment maintenance response - missing ID', type: 'danger' }));
                  setIsLoading(false);
                  return;
                }
              } else {
                console.error('Webcam modal: Invalid auxiliary equipment maintenance response structure:', auxiliaryResponse);
                dispatch(showToast({ message: 'Invalid auxiliary equipment maintenance response', type: 'danger' }));
                setIsLoading(false);
                return;
              }
            } catch (auxiliaryError) {
              console.error('Webcam modal: Failed to save auxiliary equipment maintenance record:', auxiliaryError);
              console.error('Webcam modal: Error details:', auxiliaryError.response || auxiliaryError);
              dispatch(showToast({ message: 'Failed to save auxiliary equipment maintenance record', type: 'danger' }));
              setIsLoading(false);
              return;
            }
          }
        } else if (context === 'forklift') {
          // For Forklift Maintenance context, call saveOrUpdateForkliftMaintenance API
          if (maintenanceData) {
            console.log('Webcam modal: Saving forklift maintenance record with data:', maintenanceData);
            
            try {
              // Prepare the correct payload structure for forklift maintenance
              const forkliftPayload = {
                id: 0,
                userId: localStorage.getItem('UserId'),
                assetNumber: maintenanceData.assetNumber,
                modelNumber: maintenanceData.modelNumber,
                serialNumber: maintenanceData.serialNumber,
                date: maintenanceData.date,
                location: maintenanceData.location,
                lastServicedBy: maintenanceData.lastServicedBy,
                lastServiceDate: maintenanceData.lastServiceDate,
                specSheetDocument: maintenanceData.specSheetDocument || '',
                serialPlateDocument: maintenanceData.serialPlateDocument || '',
                serviceManualDocument: maintenanceData.serviceManualDocument || '',
                serviceContactDocument: maintenanceData.serviceContactDocument || '',
                oilUsedDocument: maintenanceData.oilUsedDocument || '',
                serviceContractDocuments: maintenanceData.serviceContractDocuments || [],
                notes: maintenanceData.notes || '',
                cellLocation: maintenanceData.cellLocation,
                forklift: maintenanceData.assetNumber,
                totalCyclesSinceLastMaint: maintenanceData.totalCyclesSinceLastMaint || 0,
                totalCyclesToDate: maintenanceData.totalCyclesToDate,
                lastMaintenanceDate: maintenanceData.lastMaintenanceDate,
                maintenanceIntervalCycles: String(maintenanceData.maintenanceIntervalCycles || 0),
                currentMaintenanceDate: maintenanceData.currentMaintenanceDate,
                version: maintenanceData.version || '',
                status: maintenanceData.status || '',
              };
              
              console.log('Webcam modal: Prepared forklift payload:', forkliftPayload);
              
              // Call saveOrUpdateForkliftMaintenance API
              const forkliftResponse = await ForkliftService.saveForkliftMaintenance(forkliftPayload);
              console.log('Webcam modal: Forklift maintenance response:', forkliftResponse);
              
              // Check if the response has the expected structure
              if (forkliftResponse && forkliftResponse.status === 200 && forkliftResponse.response) {
                const responseData = forkliftResponse.response;
                if (responseData.id || responseData.ID) {
                  finalMaintenanceId = responseData.id || responseData.ID;
                  console.log('Webcam modal: Final forklift maintenance ID:', finalMaintenanceId);
                  dispatch(showToast({ message: 'Forklift maintenance record saved successfully', type: 'success' }));
                  
                  // Call the callback to update the parent component's maintenanceId
                  if (onMaintenanceSaved && typeof onMaintenanceSaved === 'function') {
                    onMaintenanceSaved(finalMaintenanceId);
                  }
                } else {
                  console.error('Webcam modal: No ID in forklift maintenance response data:', responseData);
                  dispatch(showToast({ message: 'Invalid forklift maintenance response - missing ID', type: 'danger' }));
                  setIsLoading(false);
                  return;
                }
              } else {
                console.error('Webcam modal: Invalid forklift maintenance response structure:', forkliftResponse);
                dispatch(showToast({ message: 'Invalid forklift maintenance response', type: 'danger' }));
                setIsLoading(false);
                return;
              }
            } catch (forkliftError) {
              console.error('Webcam modal: Failed to save forklift maintenance record:', forkliftError);
              console.error('Webcam modal: Error details:', forkliftError.response || forkliftError);
              dispatch(showToast({ message: 'Failed to save forklift maintenance record', type: 'danger' }));
              setIsLoading(false);
              return;
            }
          }
        } else if (context === 'water-towers') {
          // For Water Towers Maintenance context, call saveOrUpdateWaterTowersMaintenance API
          if (maintenanceData) {
            console.log('Webcam modal: Saving water towers maintenance record with data:', maintenanceData);
            
            try {
              // Prepare the correct payload structure for water towers maintenance
              const waterTowersPayload = {
                id: 0,
                userId: localStorage.getItem('UserId'),
                assetNumber: maintenanceData.assetNumber,
                modelNumber: maintenanceData.modelNumber,
                serialNumber: maintenanceData.serialNumber,
                date: maintenanceData.date,
                location: maintenanceData.location,
                lastServicedBy: maintenanceData.lastServicedBy,
                lastServiceDate: maintenanceData.lastServiceDate,
                specSheetDocument: maintenanceData.specSheetDocument || '',
                serialPlateDocument: maintenanceData.serialPlateDocument || '',
                serviceManualDocument: maintenanceData.serviceManualDocument || '',
                serviceContactDocument: maintenanceData.serviceContactDocument || '',
                oilUsedDocument: maintenanceData.oilUsedDocument || '',
                serviceContractDocuments: maintenanceData.serviceContractDocuments || [],
                notes: maintenanceData.notes || '',
                cellLocation: maintenanceData.cellLocation,
                waterTowers: maintenanceData.assetNumber,
                totalCyclesSinceLastMaint: maintenanceData.totalCyclesSinceLastMaint || 0,
                totalCyclesToDate: maintenanceData.totalCyclesToDate,
                lastMaintenanceDate: maintenanceData.lastMaintenanceDate,
                maintenanceIntervalCycles: String(maintenanceData.maintenanceIntervalCycles || 0),
                currentMaintenanceDate: maintenanceData.currentMaintenanceDate,
                version: maintenanceData.version || '',
                status: maintenanceData.status || '',
              };
              
              console.log('Webcam modal: Prepared water towers payload:', waterTowersPayload);
              
              // Call saveOrUpdateWaterTowersMaintenance API
              const waterTowersResponse = await WaterTowersService.saveWaterTowersMaintenance(waterTowersPayload);
              console.log('Webcam modal: Water towers maintenance response:', waterTowersResponse);
              
              // Check if the response has the expected structure
              if (waterTowersResponse && waterTowersResponse.status === 200 && waterTowersResponse.response) {
                const responseData = waterTowersResponse.response;
                if (responseData.id || responseData.ID) {
                  finalMaintenanceId = responseData.id || responseData.ID;
                  console.log('Webcam modal: Final water towers maintenance ID:', finalMaintenanceId);
                  dispatch(showToast({ message: 'Water towers maintenance record saved successfully', type: 'success' }));
                  
                  // Call the callback to update the parent component's maintenanceId
                  if (onMaintenanceSaved && typeof onMaintenanceSaved === 'function') {
                    onMaintenanceSaved(finalMaintenanceId);
                  }
                } else {
                  console.error('Webcam modal: No ID in water towers maintenance response data:', responseData);
                  dispatch(showToast({ message: 'Invalid water towers maintenance response - missing ID', type: 'danger' }));
                  setIsLoading(false);
                  return;
                }
              } else {
                console.error('Webcam modal: Invalid water towers maintenance response structure:', waterTowersResponse);
                dispatch(showToast({ message: 'Invalid water towers maintenance response', type: 'danger' }));
                setIsLoading(false);
                return;
              }
            } catch (waterTowersError) {
              console.error('Webcam modal: Failed to save water towers maintenance record:', waterTowersError);
              console.error('Webcam modal: Error details:', waterTowersError.response || waterTowersError);
              dispatch(showToast({ message: 'Failed to save water towers maintenance record', type: 'danger' }));
              setIsLoading(false);
              return;
            }
          }
        } else if (context === 'air-compressors') {
          // For Air Compressors Maintenance context, call saveOrUpdateAirCompressorsMaintenance API
          if (maintenanceData) {
            console.log('Webcam modal: Saving air compressors maintenance record with data:', maintenanceData);
            
            try {
              // Prepare the correct payload structure for air compressors maintenance
              const airCompressorsPayload = {
                id: 0,
                userId: localStorage.getItem('UserId'),
                assetNumber: maintenanceData.assetNumber,
                modelNumber: maintenanceData.modelNumber,
                serialNumber: maintenanceData.serialNumber,
                date: maintenanceData.date,
                location: maintenanceData.location,
                lastServicedBy: maintenanceData.lastServicedBy,
                lastServiceDate: maintenanceData.lastServiceDate,
                specSheetDocument: maintenanceData.specSheetDocument || '',
                serialPlateDocument: maintenanceData.serialPlateDocument || '',
                serviceManualDocument: maintenanceData.serviceManualDocument || '',
                serviceContactDocument: maintenanceData.serviceContactDocument || '',
                oilUsedDocument: maintenanceData.oilUsedDocument || '',
                serviceContractDocuments: maintenanceData.serviceContractDocuments || [],
                notes: maintenanceData.notes || '',
                cellLocation: maintenanceData.cellLocation,
                airCompressors: maintenanceData.assetNumber,
                totalCyclesSinceLastMaint: maintenanceData.totalCyclesSinceLastMaint || 0,
                totalCyclesToDate: maintenanceData.totalCyclesToDate,
                lastMaintenanceDate: maintenanceData.lastMaintenanceDate,
                maintenanceIntervalCycles: String(maintenanceData.maintenanceIntervalCycles || 0),
                currentMaintenanceDate: maintenanceData.currentMaintenanceDate,
                version: maintenanceData.version || '',
                status: maintenanceData.status || '',
              };
              
              console.log('Webcam modal: Prepared air compressors payload:', airCompressorsPayload);
              
              // Call saveOrUpdateAirCompressorsMaintenance API
              const airCompressorsResponse = await AirCompressorsService.saveAirCompressorsMaintenance(airCompressorsPayload);
              console.log('Webcam modal: Air compressors maintenance response:', airCompressorsResponse);
              
              // Check if the response has the expected structure
              if (airCompressorsResponse && airCompressorsResponse.status === 200 && airCompressorsResponse.response) {
                const responseData = airCompressorsResponse.response;
                if (responseData.id || responseData.ID) {
                  finalMaintenanceId = responseData.id || responseData.ID;
                  console.log('Webcam modal: Final air compressors maintenance ID:', finalMaintenanceId);
                  dispatch(showToast({ message: 'Air compressors maintenance record saved successfully', type: 'success' }));
                  
                  // Call the callback to update the parent component's maintenanceId
                  if (onMaintenanceSaved && typeof onMaintenanceSaved === 'function') {
                    onMaintenanceSaved(finalMaintenanceId);
                  }
                } else {
                  console.error('Webcam modal: No ID in air compressors maintenance response data:', responseData);
                  dispatch(showToast({ message: 'Invalid air compressors maintenance response - missing ID', type: 'danger' }));
                  setIsLoading(false);
                  return;
                }
              } else {
                console.error('Webcam modal: Invalid air compressors maintenance response structure:', airCompressorsResponse);
                dispatch(showToast({ message: 'Invalid air compressors maintenance response', type: 'danger' }));
                setIsLoading(false);
                return;
              }
            } catch (airCompressorsError) {
              console.error('Webcam modal: Failed to save air compressors maintenance record:', airCompressorsError);
              console.error('Webcam modal: Error details:', airCompressorsError.response || airCompressorsError);
              dispatch(showToast({ message: 'Failed to save air compressors maintenance record', type: 'danger' }));
              setIsLoading(false);
              return;
            }
          }
        } else if (context === 'plant') {
          // For Plant Maintenance context, call saveOrUpdatePlantMaintenance API
          if (maintenanceData) {
            console.log('Webcam modal: Saving plant maintenance record with data:', maintenanceData);
            
            try {
              // Prepare the correct payload structure for plant maintenance
              const plantPayload = {
                id: 0,
                userId: localStorage.getItem('UserId'),
                assetNumber: maintenanceData.assetNumber,
                modelNumber: maintenanceData.modelNumber,
                serialNumber: maintenanceData.serialNumber,
                date: maintenanceData.date,
                location: maintenanceData.location,
                lastServicedBy: maintenanceData.lastServicedBy,
                lastServiceDate: maintenanceData.lastServiceDate,
                specSheetDocument: maintenanceData.specSheetDocument || '',
                serialPlateDocument: maintenanceData.serialPlateDocument || '',
                serviceManualDocument: maintenanceData.serviceManualDocument || '',
                serviceContactDocument: maintenanceData.serviceContactDocument || '',
                oilUsedDocument: maintenanceData.oilUsedDocument || '',
                serviceContractDocuments: maintenanceData.serviceContractDocuments || [],
                notes: maintenanceData.notes || '',
                cellLocation: maintenanceData.cellLocation,
                plant: maintenanceData.assetNumber,
                totalCyclesSinceLastMaint: maintenanceData.totalCyclesSinceLastMaint || 0,
                totalCyclesToDate: maintenanceData.totalCyclesToDate,
                lastMaintenanceDate: maintenanceData.lastMaintenanceDate,
                maintenanceIntervalCycles: String(maintenanceData.maintenanceIntervalCycles || 0),
                currentMaintenanceDate: maintenanceData.currentMaintenanceDate,
                version: maintenanceData.version || '',
                status: maintenanceData.status || '',
              };
              
              console.log('Webcam modal: Prepared plant payload:', plantPayload);
              
              // Call saveOrUpdatePlantMaintenance API
              const plantResponse = await PlantService.savePlantMaintenance(plantPayload);
              console.log('Webcam modal: Plant maintenance response:', plantResponse);
              
              // Check if the response has the expected structure
              if (plantResponse && plantResponse.status === 200 && plantResponse.response) {
                const responseData = plantResponse.response;
                if (responseData.id || responseData.ID) {
                  finalMaintenanceId = responseData.id || responseData.ID;
                  console.log('Webcam modal: Final plant maintenance ID:', finalMaintenanceId);
                  dispatch(showToast({ message: 'Plant maintenance record saved successfully', type: 'success' }));
                  
                  // Call the callback to update the parent component's maintenanceId
                  if (onMaintenanceSaved && typeof onMaintenanceSaved === 'function') {
                    onMaintenanceSaved(finalMaintenanceId);
                  }
                } else {
                  console.error('Webcam modal: No ID in plant maintenance response data:', responseData);
                  dispatch(showToast({ message: 'Invalid plant maintenance response - missing ID', type: 'danger' }));
                  setIsLoading(false);
                  return;
                }
              } else {
                console.error('Webcam modal: Invalid plant maintenance response structure:', plantResponse);
                dispatch(showToast({ message: 'Invalid plant maintenance response', type: 'danger' }));
                setIsLoading(false);
                return;
              }
            } catch (plantError) {
              console.error('Webcam modal: Failed to save plant maintenance record:', plantError);
              console.error('Webcam modal: Error details:', plantError.response || plantError);
              dispatch(showToast({ message: 'Failed to save plant maintenance record', type: 'danger' }));
              setIsLoading(false);
              return;
            }
          }
        } else if (context === 'robots') {
          // For Robots Maintenance context, call saveOrUpdateRobotsMaintenance API
          if (maintenanceData) {
            console.log('Webcam modal: Saving robots maintenance record with data:', maintenanceData);
            
            try {
              // Prepare the correct payload structure for robots maintenance
              const robotsPayload = {
                id: 0,
                userId: localStorage.getItem('UserId'),
                assetNumber: maintenanceData.assetNumber,
                modelNumber: maintenanceData.modelNumber,
                serialNumber: maintenanceData.serialNumber,
                date: maintenanceData.date,
                location: maintenanceData.location,
                lastServicedBy: maintenanceData.lastServicedBy,
                lastServiceDate: maintenanceData.lastServiceDate,
                specSheetDocument: maintenanceData.specSheetDocument || '',
                serialPlateDocument: maintenanceData.serialPlateDocument || '',
                serviceManualDocument: maintenanceData.serviceManualDocument || '',
                serviceContactDocument: maintenanceData.serviceContactDocument || '',
                oilUsedDocument: maintenanceData.oilUsedDocument || '',
                serviceContractDocuments: maintenanceData.serviceContractDocuments || [],
                notes: maintenanceData.notes || '',
                cellLocation: maintenanceData.cellLocation,
                robots: maintenanceData.assetNumber,
                totalCyclesSinceLastMaint: maintenanceData.totalCyclesSinceLastMaint || 0,
                totalCyclesToDate: maintenanceData.totalCyclesToDate,
                lastMaintenanceDate: maintenanceData.lastMaintenanceDate,
                maintenanceIntervalCycles: String(maintenanceData.maintenanceIntervalCycles || 0),
                currentMaintenanceDate: maintenanceData.currentMaintenanceDate,
                version: maintenanceData.version || '',
                status: maintenanceData.status || '',
              };
              
              console.log('Webcam modal: Prepared robots payload:', robotsPayload);
              
              // Call saveOrUpdateRobotsMaintenance API
              const robotsResponse = await RobotsService.saveRobotsMaintenance(robotsPayload);
              console.log('Webcam modal: Robots maintenance response:', robotsResponse);
              
              // Check if the response has the expected structure
              if (robotsResponse && robotsResponse.status === 200 && robotsResponse.response) {
                const responseData = robotsResponse.response;
                if (responseData.id || responseData.ID) {
                  finalMaintenanceId = responseData.id || responseData.ID;
                  console.log('Webcam modal: Final robots maintenance ID:', finalMaintenanceId);
                  dispatch(showToast({ message: 'Robots maintenance record saved successfully', type: 'success' }));
                  
                  // Call the callback to update the parent component's maintenanceId
                  if (onMaintenanceSaved && typeof onMaintenanceSaved === 'function') {
                    onMaintenanceSaved(finalMaintenanceId);
                  }
                } else {
                  console.error('Webcam modal: No ID in robots maintenance response data:', responseData);
                  dispatch(showToast({ message: 'Invalid robots maintenance response - missing ID', type: 'danger' }));
                  setIsLoading(false);
                  return;
                }
              } else {
                console.error('Webcam modal: Invalid robots maintenance response structure:', robotsResponse);
                dispatch(showToast({ message: 'Invalid robots maintenance response', type: 'danger' }));
                setIsLoading(false);
                return;
              }
            } catch (robotsError) {
              console.error('Webcam modal: Failed to save robots maintenance record:', robotsError);
              console.error('Webcam modal: Error details:', robotsError.response || robotsError);
              dispatch(showToast({ message: 'Failed to save robots maintenance record', type: 'danger' }));
              setIsLoading(false);
              return;
            }
          }
        } else if (context === 'overhead-crane') {
          // For Overhead Crane Maintenance context, call saveOrUpdateOverheadCraneMaintenance API
          if (maintenanceData) {
            console.log('Webcam modal: Saving overhead crane maintenance record with data:', maintenanceData);
            
            try {
              // Prepare the correct payload structure for overhead crane maintenance
              const overheadCranePayload = {
                id: 0,
                userId: localStorage.getItem('UserId'),
                assetNumber: maintenanceData.assetNumber,
                modelNumber: maintenanceData.modelNumber,
                serialNumber: maintenanceData.serialNumber,
                date: maintenanceData.date,
                location: maintenanceData.location,
                lastServicedBy: maintenanceData.lastServicedBy,
                lastServiceDate: maintenanceData.lastServiceDate,
                specSheetDocument: maintenanceData.specSheetDocument || '',
                serialPlateDocument: maintenanceData.serialPlateDocument || '',
                serviceManualDocument: maintenanceData.serviceManualDocument || '',
                serviceContactDocument: maintenanceData.serviceContactDocument || '',
                oilUsedDocument: maintenanceData.oilUsedDocument || '',
                serviceContractDocuments: maintenanceData.serviceContractDocuments || [],
                notes: maintenanceData.notes || '',
                cellLocation: maintenanceData.cellLocation,
                overheadCrane: maintenanceData.assetNumber,
                totalCyclesSinceLastMaint: maintenanceData.totalCyclesSinceLastMaint || 0,
                totalCyclesToDate: maintenanceData.totalCyclesToDate,
                lastMaintenanceDate: maintenanceData.lastMaintenanceDate,
                maintenanceIntervalCycles: String(maintenanceData.maintenanceIntervalCycles || 0),
                currentMaintenanceDate: maintenanceData.currentMaintenanceDate,
                version: maintenanceData.version || '',
                status: maintenanceData.status || '',
              };
              
              console.log('Webcam modal: Prepared overhead crane payload:', overheadCranePayload);
              
              // Call saveOrUpdateOverheadCraneMaintenance API
              const overheadCraneResponse = await OverheadCraneService.saveOverheadCraneMaintenance(overheadCranePayload);
              console.log('Webcam modal: Overhead crane maintenance response:', overheadCraneResponse);
              
              // Check if the response has the expected structure
              if (overheadCraneResponse && overheadCraneResponse.status === 200 && overheadCraneResponse.response) {
                const responseData = overheadCraneResponse.response;
                if (responseData.id || responseData.ID) {
                  finalMaintenanceId = responseData.id || responseData.ID;
                  console.log('Webcam modal: Final overhead crane maintenance ID:', finalMaintenanceId);
                  dispatch(showToast({ message: 'Overhead crane maintenance record saved successfully', type: 'success' }));
                  
                  // Call the callback to update the parent component's maintenanceId
                  if (onMaintenanceSaved && typeof onMaintenanceSaved === 'function') {
                    onMaintenanceSaved(finalMaintenanceId);
                  }
                } else {
                  console.error('Webcam modal: No ID in overhead crane maintenance response data:', responseData);
                  dispatch(showToast({ message: 'Invalid overhead crane maintenance response - missing ID', type: 'danger' }));
                  setIsLoading(false);
                  return;
                }
              } else {
                console.error('Webcam modal: Invalid overhead crane maintenance response structure:', overheadCraneResponse);
                dispatch(showToast({ message: 'Invalid overhead crane maintenance response', type: 'danger' }));
                setIsLoading(false);
                return;
              }
            } catch (overheadCraneError) {
              console.error('Webcam modal: Failed to save overhead crane maintenance record:', overheadCraneError);
              console.error('Webcam modal: Error details:', overheadCraneError.response || overheadCraneError);
              dispatch(showToast({ message: 'Failed to save overhead crane maintenance record', type: 'danger' }));
              setIsLoading(false);
              return;
            }
          }
        } else if (context === 'maintenance-records') {
          // For Maintenance Records context, call saveMachineMaintenanceAllRecords API
          if (maintenanceData) {
            console.log('Webcam modal: Saving maintenance record with data:', maintenanceData);
            
            try {
                             // Prepare the correct payload structure for maintenance records
               const maintenanceRecordPayload = {
                 ...maintenanceData,
                 maintenanceId: maintenanceData.id || 0, // Use maintenanceId instead of id
                 id: maintenanceData.id || 0, // Keep id as well for compatibility
                 userId: localStorage.getItem('UserId'),
                 serviceRecords: maintenanceData.serviceRecords || [],
                 personnelRecords: maintenanceData.personnelRecords || [],
                 safetyChecklist: maintenanceData.safetyChecklist || [],
               };
               const isNewMaintenanceRecord =
                 !maintenanceData.id || Number(maintenanceData.id) === 0;
               if (isNewMaintenanceRecord) {
                 maintenanceRecordPayload.workOrderNumber = null;
               }
              
              console.log('Webcam modal: Prepared maintenance record payload:', maintenanceRecordPayload);
              
              // Call saveMachineMaintenanceAllRecords API
              const maintenanceResponse = await CellService.createMachineMaintenanceAllRecords(maintenanceRecordPayload);
              console.log('Webcam modal: Maintenance record response:', maintenanceResponse);
              
                             // Check if the response has the expected structure
               console.log('Webcam modal: Full maintenance record response:', maintenanceResponse);
               
               // Handle different possible response structures
               let responseData = null;
               let maintenanceId = null;
               
               if (maintenanceResponse && maintenanceResponse.status === 200) {
                 // Try different response structures
                 if (maintenanceResponse.response) {
                   responseData = maintenanceResponse.response;
                 } else if (maintenanceResponse.data) {
                   responseData = maintenanceResponse.data;
                 } else {
                   responseData = maintenanceResponse;
                 }
                 
                 // Try to extract the ID from different possible fields
                 maintenanceId = responseData.id || responseData.ID || responseData.maintenanceId || responseData.maintenanceID || responseData.MaintenanceId || responseData.MaintenanceID;
                 
                 if (maintenanceId) {
                   finalMaintenanceId = maintenanceId;
                   console.log('Webcam modal: Final maintenance record ID:', finalMaintenanceId);
                   dispatch(showToast({ message: 'Maintenance record saved successfully', type: 'success' }));
                   
                   const savedWo =
                     responseData.workOrderNumber ??
                     responseData.WorkOrderNumber ??
                     null;
                   if (onMaintenanceSaved && typeof onMaintenanceSaved === 'function') {
                     onMaintenanceSaved(finalMaintenanceId, savedWo);
                   }
                 } else {
                   console.error('Webcam modal: No ID found in maintenance record response data:', responseData);
                   console.error('Webcam modal: Available fields in response:', Object.keys(responseData));
                   dispatch(showToast({ message: 'Invalid maintenance record response - missing ID', type: 'danger' }));
                   setIsLoading(false);
                   return;
                 }
               } else {
                 console.error('Webcam modal: Invalid maintenance record response structure:', maintenanceResponse);
                 dispatch(showToast({ message: 'Invalid maintenance record response', type: 'danger' }));
                 setIsLoading(false);
                 return;
               }
            } catch (maintenanceError) {
              console.error('Webcam modal: Failed to save maintenance record:', maintenanceError);
              console.error('Webcam modal: Error details:', maintenanceError.response || maintenanceError);
              dispatch(showToast({ message: 'Failed to save maintenance record', type: 'danger' }));
              setIsLoading(false);
              return;
            }
          }
        } else {
        // For Maintenance context, check if we need to call saveOrUpdateMoldMaintenance
        if (!maintenanceId || maintenanceId === 0) {
          // No maintenanceId exists, need to call saveUpdateMaintenance first
          console.log('Webcam modal: No maintenanceId exists, calling saveUpdateMaintenance');
          
          if (maintenanceData) {
            try {
              // Normalize maintenanceData to handle both lowercase and uppercase field names
              const normalizedMaintenanceData = {
                ...maintenanceData,
                // Use uppercase fields if lowercase fields are undefined
                maintenanceTypes: maintenanceData?.maintenanceTypes || maintenanceData?.MaintenanceType,
                toolID: maintenanceData?.toolID || maintenanceData?.ToolID,
                moldInfoID: maintenanceData?.moldInfoID || maintenanceData?.MoldInfoID,
                id: maintenanceData?.id || maintenanceData?.ID,
              };
              
              console.log('Webcam modal: Saving mold maintenance record with data:', normalizedMaintenanceData);
              
              // Call saveUpdateMaintenance API
              const maintenanceResponse = await MoldService.saveUpdateMaintenance(normalizedMaintenanceData);
              console.log('Webcam modal: Mold maintenance response:', maintenanceResponse);
              
              if (maintenanceResponse && maintenanceResponse.status === 200 && maintenanceResponse.response) {
                const responseData = maintenanceResponse.response;
                if (responseData.id || responseData.ID) {
                  finalMaintenanceId = responseData.id || responseData.ID;
                  console.log('Webcam modal: Final maintenance ID:', finalMaintenanceId);
                  dispatch(showToast({ message: 'Mold maintenance record saved successfully', type: 'success' }));
                  
                  // Call the callback to update the parent component's maintenanceId
                  if (onMaintenanceSaved && typeof onMaintenanceSaved === 'function') {
                    onMaintenanceSaved(finalMaintenanceId);
                  }
                } else {
                  console.error('Webcam modal: No ID in maintenance response data:', responseData);
                  dispatch(showToast({ message: 'Invalid maintenance response - missing ID', type: 'danger' }));
                  setIsLoading(false);
                  return;
                }
              } else {
                console.error('Webcam modal: Invalid maintenance response structure:', maintenanceResponse);
                dispatch(showToast({ message: 'Invalid maintenance response', type: 'danger' }));
                setIsLoading(false);
                return;
              }
            } catch (maintenanceError) {
              console.error('Webcam modal: Failed to save mold maintenance record:', maintenanceError);
              dispatch(showToast({ message: 'Failed to save mold maintenance record', type: 'danger' }));
              setIsLoading(false);
              return;
            }
          } else {
            console.error('Webcam modal: No maintenance data provided');
            dispatch(showToast({ message: 'No maintenance data provided', type: 'danger' }));
            setIsLoading(false);
            return;
          }
        } else {
          // maintenanceId already exists, skip saveUpdateMaintenance
          console.log('Webcam modal: maintenanceId already exists, skipping saveUpdateMaintenance:', maintenanceId);
          finalMaintenanceId = maintenanceId;
        }
      }

      // Now upload images and call saveOrUpdateMoldImageSegments
      const uploadedFiles = [];

      for (const { slot, img } of pendingImages) {
        try {
          const response = await fetch(img.src);
          const blob = await response.blob();
          const safeTimestamp = new Date().toISOString().replace(/[:.]/g, '-');
          const file = new File([blob], `${slot.label}_${safeTimestamp}.jpg`, {
            type: 'image/jpeg',
          });

          const fileCategoryId = sanitizeUploadKey(MOLD_TYPE.WEBCAM_CAPTURED_IMAGE);
          // Determine upload category based on context
          let uploadCategory;
          if (context === 'receiving') {
            uploadCategory = sanitizeUploadKey(MOLD_TYPE.MOLD_RECEIVING);
          } else if (context === 'release') {
            uploadCategory = sanitizeUploadKey(MOLD_TYPE.MOLD_RELEASE);
          } else {
            // Default to MOLD_MAINTENANCE for maintenance, maintenance-records, and all other contexts
            uploadCategory = sanitizeUploadKey(MOLD_TYPE.MOLD_MAINTENANCE);
          }
         
          const docFormData = new FormData();
          docFormData.append('file', file);
          docFormData.append('fileCategoryId', fileCategoryId);
          docFormData.append('uploadCategory', uploadCategory);

          const result = await imageDocuments(docFormData);

          if (result && result.relativePath) {
            uploadedFiles.push({
              fileName: file.name,
              relativePath: result.relativePath,
              filePath: result.relativePath,
              slotName: slot.label,
            });

                         // Call saveOrUpdateMoldImageSegments API
             try {
                                               const segmentData = {
                  moldInfoID: context === 'receiving' ? finalMoldInfoId : context === 'release' ? finalMoldReceivingId : context === 'machine' ? 0 : context === 'maintenance-records' ? 0 : moldInfoID,
                  imageUrl: result.relativePath,
                  segment: slot.label,
                  record: context === 'release' ? buttonLabel : context === 'machine' ? buttonLabel : context === 'maintenance-records' ? buttonLabel : buttonLabel, // For machine, use the document type (Serial Plate)
                  maintenanceId: context === 'receiving' ? 0 : context === 'release' ? 0 : context === 'machine' ? finalMaintenanceId : context === 'maintenance-records' ? finalMaintenanceId : finalMaintenanceId, // machine maintenance ID for machine context
                  title: '',
                  description: '',
                  category: context === 'receiving' ? 'Mold-Receiving' : context === 'release' ? 'Mold-Release' : context === 'machine' ? 'Machine-Maintenance' : context === 'maintenance-records' ? 'Machine-Maintenance-Records' : context === 'auxiliary-equipment' ? 'Auxiliary-Equipment-Maintenance' : context === 'forklift' ? 'Forklift-Maintenance' : context === 'water-towers' ? 'Water-Towers-Maintenance' : context === 'air-compressors' ? 'Air-Compressors-Maintenance' : context === 'plant' ? 'Plant-Maintenance' : context === 'robots' ? 'Robots-Maintenance' : context === 'overhead-crane' ? 'Overhead-Crane-Maintenance' : 'Mold_Maintenance'
                };
                 
                 console.log('Webcam modal: Saving image segment with data:', segmentData);
                 console.log('Webcam modal: Using moldInfoID for image segment:', segmentData.moldInfoID);
              
              await MoldService.saveUpdateImageSegments(segmentData);
              
              // Track uploaded image URLs for cleanup if needed
              setUploadedImageUrls(prev => [...prev, result.relativePath]);
              
              // Notify parent about uploaded image segment
              if (onImageSegmentUploaded && typeof onImageSegmentUploaded === 'function') {
                onImageSegmentUploaded(slot.label, buttonLabel);
              }
            } catch (segmentError) {
              console.error('Failed to save image segment:', segmentError);
              // Don't fail the entire upload process if segment saving fails
            }
          }
        } catch (err) {
          console.error('Image upload failed', err);
        }
      }
      
      if (uploadedFiles.length > 0) {
        dispatch(showToast({ message: 'All Images Uploaded', type: 'success' }));
      }
      
      setSlotImages({});
      setPendingImages([]);
      onClose();
      onSubmit(uploadedFiles);
      
    } catch (error) {
      console.error('Upload process failed:', error);
      dispatch(showToast({ message: 'Upload process failed', type: 'danger' }));
    } finally {
      setIsLoading(false);
    }
  };

            

     // Handle modal close
     const handleClose = () => {
       setSlotImages({});
       setUploadedImageUrls([]);
       onClose();
     };

  return (
    <>
             <Modal show={show} onHide={handleClose} centered dialogClassName="webcam-modal">
        {isLoading && <LoadingSpinner isGlobal={false} />}
      <Modal.Header closeButton>
        <Modal.Title>Capture Images</Modal.Title>
      </Modal.Header>
      <Modal.Body className="webcam-modal-body">
        <div className="capture-layout">
          {/* Slots on the left */}
          <div className="slot-list">
            {slots.map(slot => (
              <div
                key={slot.key}
                className={`slot-item ${activeSlot === slot.key ? 'active' : ''}`}
                onClick={() => setActiveSlot(slot.key)}
              >
                <input
                  type="text"
                  className="slot-label-input"
                  value={slot.label}
                  onChange={e =>
                    setSlots(prev =>
                      prev.map(s => (s.key === slot.key ? { ...s, label: e.target.value } : s)),
                    )
                  }
                />
              </div>
            ))}

            <Button size="sm" variant="outline-primary" className="mt-2" onClick={addSlot}>
              + Add Segment
            </Button>
          </div>

          {/* Webcam on the right */}
          <div className="webcam-container">
            <Webcam
              key={facingMode}
              audio={false}
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              width={500}
              height={350}
              videoConstraints={videoConstraints}
            />
          </div>
        </div>

        <div className="action-buttons">
          <Button 
            size="sm" 
            variant="secondary" 
            onClick={flipCamera} 
            className="action-btn"
            disabled={isCameraLoading}
          >
            {isCameraLoading ? (
              <div className="spinner-border spinner-border-sm me-2" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            ) : (
              <FaSyncAlt />
            )}
            {isCameraLoading ? 'Switching Camera...' : 'Flip Camera'}
          </Button>
          <Button size="sm" variant="primary" onClick={captureImage} className="action-btn">
            <FaCamera />
            Capture Photo
          </Button>
          <Button 
            size="sm" 
            variant="success" 
            onClick={() => setShowUploadArea(!showUploadArea)} 
            className="action-btn"
          >
            <FaUpload />
            Upload Images
          </Button>
        </div>

        {/* Upload area */}
        {showUploadArea && (
          <div className="upload-area mt-3">
            <div 
              className="upload-zone"
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
            >
              <label htmlFor="file-upload-input" className="upload-label">
                <FaUpload className="upload-icon" />
                <div className="upload-text">
                  <span className="upload-bold">Click to upload</span> or drag and drop
                </div>
                <div className="upload-subtext">PNG, JPG, GIF, HEIC up to 10MB</div>
                <input
                  id="file-upload-input"
                  type="file"
                  multiple
                  accept="image/*,.heic,.heif"
                  onChange={handleFileSelect}
                  style={{ display: 'none' }}
                />
              </label>
            </div>
          </div>
        )}

        {/* Captured images grid grouped by slot */}
        <div className="captured-grid mt-3 w-100">
          {slots.map(slot => {
            const images = slotImages[slot.key] || [];
            if (images.length === 0) return null;
            return (
              <div key={slot.key} className="slot-grid">
                <h6>{slot.label}</h6>
                <div className="slot-images">
                  {images.map(img => (
                    <div key={img.id} className="thumbnail">
                      <img 
                        src={img.src} 
                        alt={slot.label} 
                        className="thumbnail-img" 
                        onClick={() => handleEditImage(slot.key, img)}
                        style={{ cursor: 'pointer' }}
                        title="Click to edit image"
                      />
                      <span
                        onClick={() => toggleSelect(slot.key, img.id)}
                        className="thumbnail-check"
                      >
                        {img.isSelected ? (
                          <FaCheckSquare color="green" />
                        ) : (
                          <FaRegSquare color="gray" />
                        )}
                      </span>
                      <button
                        className="remove-thumbnail-btn"
                        onClick={() => removeImage(slot.key, img.id)}
                        title="Remove image"
                      >
                        <FaTimes />
                      </button>
                      {img.isEdited && (
                        <span className="edited-badge" title="Image has been edited">
                          ✓ Edited
                        </span>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </Modal.Body>
      
      {/* Processing Images Loader Overlay */}
      {isProcessingImages && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 10000,
            backdropFilter: 'blur(4px)'
          }}
        >
          <div 
            style={{
              backgroundColor: 'white',
              borderRadius: '12px',
              padding: '40px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
              textAlign: 'center',
              minWidth: '300px',
              maxWidth: '500px'
            }}
          >
            <div 
              className="spinner-border text-primary" 
              role="status"
              style={{
                width: '80px',
                height: '80px',
                borderWidth: '8px',
                marginBottom: '20px'
              }}
            >
              <span className="visually-hidden">Processing...</span>
            </div>
            <h4 style={{ marginBottom: '15px', color: '#333', fontWeight: '600' }}>
              Processing Images
            </h4>
            <p style={{ color: '#666', marginBottom: '20px', fontSize: '16px' }}>
              {processingProgress.current} of {processingProgress.total} images processed
            </p>
            <div 
              className="progress" 
              style={{ 
                height: '12px', 
                borderRadius: '6px',
                backgroundColor: '#e9ecef',
                overflow: 'hidden'
              }}
            >
              <div 
                className="progress-bar progress-bar-striped progress-bar-animated bg-primary" 
                role="progressbar"
                style={{ 
                  width: `${(processingProgress.current / processingProgress.total) * 100}%`,
                  height: '100%',
                  transition: 'width 0.3s ease'
                }}
                aria-valuenow={processingProgress.current}
                aria-valuemin="0"
                aria-valuemax={processingProgress.total}
              >
                {Math.round((processingProgress.current / processingProgress.total) * 100)}%
              </div>
            </div>
            <p style={{ color: '#999', marginTop: '15px', fontSize: '14px' }}>
              Please wait while we convert and compress your images...
            </p>
          </div>
        </div>
      )}
      
      <Modal.Footer>
                 <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant="success"
          onClick={handleSubmit}
          disabled={
            Object.values(slotImages)
              .flat()
              .filter(i => i.isSelected).length === 0 || isLoading
          }
        >
          {isLoading ? (
            <>
              <div className="spinner-border spinner-border-sm me-2" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              Uploading Images...
            </>
          ) : (
            'Save Selected Images'
          )}
        </Button>
      </Modal.Footer>
    </Modal>

    {/* Confirmation Dialog */}
    <Modal show={showConfirmDialog} onHide={() => setShowConfirmDialog(false)} centered size="sm">
      <Modal.Header closeButton>
        <Modal.Title>Confirm Save</Modal.Title>
      </Modal.Header>
      <Modal.Body>
                        <p>Do you want to save this {context === 'receiving' ? 'mold receiving' : context === 'release' ? 'mold release' : context === 'machine' ? 'machine maintenance' : context === 'maintenance-records' ? 'maintenance record' : context === 'auxiliary-equipment' ? 'auxiliary equipment maintenance' : context === 'forklift' ? 'forklift maintenance' : context === 'water-towers' ? 'water towers maintenance' : context === 'air-compressors' ? 'air compressors maintenance' : context === 'plant' ? 'plant maintenance' : context === 'robots' ? 'robots maintenance' : context === 'overhead-crane' ? 'overhead crane maintenance' : 'maintenance'}?</p>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-end">
        <Button variant="primary" onClick={handleConfirmSubmit}>
          Yes
        </Button>
          <Button variant="secondary" onClick={() => setShowConfirmDialog(false)}>
          No
        </Button>
      </Modal.Footer>
    </Modal>

    {/* Image Editor Modal */}
    {editingImage && (
      <ZoomableImageModal
        show={showImageEditor}
        onHide={() => {
          setShowImageEditor(false);
          setEditingImage(null);
          setEditingSlot(null);
        }}
        imageSrc={editingImage.src}
        imageAlt="Captured Image"
        enableEditor={true}
        onSaveEdited={handleSaveEditedImage}
      />
    )}
    </>
  );
};

export default WebcamMultiCaptureModal;